<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    let status = {"k0":"未启用","k1":"启用"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            this.formData.cols = [
                { title: window.$t('txmis.common.phone'), field: 'phone'},
                { title: window.$t('txmis.common.idNumber'), field: 'idNumber'},
                { title: 'ip', field: 'ip'},
                {click:window.$t('txmis.bt.search'),auth:"newmis36.white.search"},
                {click:window.$t('txmis.bt.add'),auth:"newmis36.white.add"},
            ]
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "delete"){
                    this.dataChanage(URL.whiteLit.deleteBatchIds,{ids:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('txmis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(URL.whiteLit.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: 'id', field: 'id',hidden:true},
                        { title: window.$t('txmis.common.createTime'), field: 'createTime',hidden:true},
                        { title: window.$t('txmis.common.phone'), field: 'phone',required:true},
                        { title: window.$t('txmis.common.idNumber'), field: 'idNumber'},
                        { title: window.$t('txmis.common.status'), field: 'status',type:2,optionList:status,isNumber:true},
                        { title: 'ip', field: 'ip'},
                        { title: window.$t('txmis.common.email'), field: 'email'},
                        { title: window.$t('txmis.common.remark'), field: 'remark'},
                    ],
                },
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.whiteLit.query, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('txmis.common.phone'), field: 'phone'},
                        { title: window.$t('txmis.common.idNumber'), field: 'idNumber'},
                        { title: window.$t('txmis.common.status'), field: 'status',render:(data,full)=> {
                            return status[data] || "";
                            }},
                        { title: 'ip', field: 'ip'},
                        { title: window.$t('txmis.common.email'), field: 'email'},
                        { title: window.$t('txmis.common.remark'), field: 'remark'},
                        { title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        { title: window.$t('txmis.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-edit",auth:"newmis36.white.edit"},
                        {field:window.$t('txmis.bt.delete'),title:window.$t('txmis.bt.operation'),size:"mini",click:"delete",type:"primary",icon:"el-icon-delete",auth:"newmis36.white.delete"},
                    ]
                }
            }
        }
    }
</script>
